const useValidationRules = () => ({
  required: (value: unknown) => (typeof value !== 'boolean' ? !!value?.toString().trim() : value) || 'Required value.',
  email: (value: string | number | undefined) => {
    const emailPattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return !value || emailPattern.test(value.toString()) || 'Invalid e-mail'
  },
  birthday: (value: string) => {
    const pattern = /(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d/
    return pattern.test(value) || 'Date format mm/dd/yyyy'
  },
  nonNegativeNumber: (value: string | number | undefined) => {
    const numberValue = Number(value)
    return (!Number.isNaN(numberValue) && numberValue >= 0) || 'Must be a non-negative number'
  },
  positiveNumber: (value: string | number | undefined) => {
    const numberValue = Number(value)
    return (!Number.isNaN(numberValue) && numberValue > 0) || 'Value must be more than 0'
  },
})

export default useValidationRules
